<template>
    <div class="l-rblock">
        <l-tree-select v-if="isLoadByCompany" v-model="selectValue" :options="departmentOptions"
            :placeholder="$t(placeholder)" :size="size" :disabled="disabled" :clearable="disabled ? false : clearable"
            @change="handleChange">
            <template #prefix v-if="canSelectCurrent && !disabled">
                <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)"
                    @click.stop="selectCurrent">
                    <i class="learun-icon-lock" :style="{ 'color': hasCurrent ? '#409eff' : '#8c8c8c' }"></i>
                </div>
            </template>
        </l-tree-select>
        <template v-else>
            <template v-if="mode == 'normal'">
                <span v-if="disabled && printMode">{{ showValue }}</span>
                <el-input v-else ref="main" :placeholder="$t(placeholder)" v-model="showValue" :size="size"
                    :clearable="disabled ? false : clearable" :disabled="disabled" style="vertical-align: middle;"
                    @clear="handleInputClear" @focus="handleShow">
                    <span slot="append" @click="handleShow">
                        <el-button slot="append" icon="learun-icon-department"></el-button>
                    </span>
                    <template slot="prepend" v-if="canSelectCurrent && !disabled">
                        <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)"
                            @click.stop="selectCurrent">
                            <i class="learun-icon-lock" :style="{ 'color': hasCurrent ? '#409eff' : '#8c8c8c' }"></i>
                        </div>
                    </template>
                </el-input>

            </template>
            <template v-else-if="mode == 'form'">
                <div class="flex" style="flex-wrap: wrap;">
                    <div class="add-btn" style="
                        width: auto;
                        padding: 0 12px;
                        display: inline-block;
                        font-size: 12px;
                        color: #2c71fa;
                        background: #f5f7f9;
                        height: 28px;
                        line-height: 28px;
                        border-radius: 14px;
                        margin: 4px 0;
                        margin-right: 8px;
                        cursor: pointer;" @click="handleShow" v-if="!disabled">
                        <i class="el-icon-plus"></i>
                        {{ $t('添加部门') }}
                    </div>
                    <l-department :canRemove="!disabled" mode="form" @remove="removeHandler"
                        v-for="i in departments.slice(0, 10)" :value="i" :key="i" />
                    <span v-if="departments.length > 10" class="pointer" @click.stop="handleShow">等{{ departments.length
                        }}个部门</span>
                </div>
            </template>
            <template v-else-if="mode == 'tag'">
                <div class="flex tag-mode" @click="handleShow" :style="{'border-width': showBorder ? '1px':'0px'}">
                    <!-- <div class="add-btn" style="
                        width: auto;
                        padding: 0 12px;
                        display: inline-block;
                        font-size: 12px;
                        color: #2c71fa;
                        background: #f5f7f9;
                        height: 28px;
                        line-height: 28px;
                        border-radius: 14px;
                        margin: 4px 0;
                        margin-right: 8px;
                        cursor: pointer;"
                        @click="handleShow"
                        v-if="!disabled">
                        <i class="el-icon-plus"></i>
                        {{$t('添加部门')}}
                    </div> -->
                    <template v-if="departments.length > 0">
                        <l-department :canRemove="!disabled" mode="form" @remove="removeHandler"
                            v-for="i in departments.slice(0, 10)" :value="i" :key="i" />
                        <span v-if="departments.length > 10" class="pointer" @click.stop="handleShow">等{{
                            departments.length }}个部门</span>
                    </template>

                    <div class="tishi" v-if="showPlaceholder && departments.length == 0">
                        <i class="el-icon-plus" style="font-size: 13px;margin-right: 2px;"></i>
                        <span style="font-size: 12px;">请选择部门</span>
                    </div>


                </div>
            </template>
        </template>
        <l-dialog v-if="!isLoadByCompany" :title="$t(placeholder)" :visible.sync="dialogVisible" :height="480"
            :hasBtns="multiple" @ok="handleSelectMultiple" @opened="handleOpened" width="600px">
            <l-layout class="l-tab-page" :left="300">
                <template #left>
                    <l-panel :title="$t('公司信息')" style="padding-right:0;">
                        <el-tree :data="companyTree" default-expand-all :expand-on-click-node="false"
                            @node-click="handleCompanyClick">
                            <span slot-scope="{ node}">
                                {{ $t(node.label) }}
                            </span>
                        </el-tree>
                    </l-panel>
                </template>
                <l-panel :title="$t('部门信息')" style="padding-left:0;">
                    <template #toolLeft>
                        <div class="l-panel--item" style="width: 100%;">
                            <el-input :placeholder="$t('请输入')" v-model="searchWord" size="mini">
                                <el-button slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </div>
                    </template>
                    <el-tree :data="departmentsTree" :show-checkbox="multiple" ref="maintree" node-key="f_DepartmentId"
                        default-expand-all :expand-on-click-node="false" @node-click="handleDepartmentClick">
                        <span slot-scope="{node}">
                            {{ $t(node.label) }}
                        </span>
                    </el-tree>
                </l-panel>
            </l-layout>
        </l-dialog>
    </div>
</template>

<script>

export default {
    name: 'l-department-select',
    props: {
        value: {},
        size: {
            type: String,
            default: 'mini'
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        companyId: {
            type: String,
            default: ''
        },
        isLoadByCompany: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        mode: {
            default: 'tag', //form、 normal
        },
        printMode: {
            default: false
        },
        canSelectCurrent: {
            default: false
        },
        showBorder: {
            default: true
        },
        showPlaceholder: {
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            selectCompanyId: '',

            text: '',
            searchWord: '',
            currentName: '所属部门'
        }
    },
    computed: {
        selectValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        departmentOptions() {
            if (this.lr_departments) {
                return this.lr_departmentTree(this.lr_departments[this.companyId])
            }
            else {
                return []
            }
        },
        hasCurrent() {
            if (!this.value) return false
            return this.value.indexOf(this.currentName) > -1
        },
        uidStr() {
            if (!this.vlaue) return ''
            return this.value.replace(`${this.currentName},`, '').replace(this.currentName, '')
        },
        departments() {
            return this.value ? this.value.split(',') : []
        },

        showValue: {
            get() {
                let arr = this.value ? this.value.split(',') : [], brr = []
                if (arr.includes(this.currentName)) {
                    brr.push(this.$t(this.currentName))
                }
                if (this.lr_departmentNameByOne) {
                    brr = brr.concat(this.lr_departmentNameByOne(arr.filter(e => e != this.currentName).join(',')))
                }
                else {
                    return this.value
                }
                return brr.filter(e => e).join(',')
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        companyTree() {
            if (this.lr_companyTree) {
                return this.lr_companyTree
            }
            else {
                return []
            }
        },
        departmentList() {
            return this.lr_departments[this.selectCompanyId]
        },
        departmentsTree() {
            if (this.lr_departments) {
                if (this.searchWord) {
                    const seachTree = this.lr_departmentTree(this.departmentList.filter(t => t.f_FullName.indexOf(this.searchWord) != -1))
                    seachTree.forEach(item => {
                        const pobj = this.departmentList.find(t => t.f_DepartmentId == item.f_ParentId)
                        if (pobj) {
                            item.label = `${pobj.f_FullName}/${item.label}`
                        }
                    })
                    return seachTree
                }
                else {
                    return this.lr_departmentTree(this.departmentList)
                }
            }
            else {
                return []
            }
        }
    },
    created() {
        this.lr_loadCompanys && this.lr_loadCompanys()
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) newVal = newVal.replace(`${this.currentName},`, '').replace(this.currentName, '')
                if (!this.$validatenull(newVal)) {
                    this.lr_loadDepartment && this.lr_loadDepartment(newVal)
                }
            },
            immediate: true
        }
    },
    methods: {
        selectCurrent() {
            let arr = this.value ? this.value.split(',') : []
            if (arr.includes(this.currentName)) {
                arr = arr.filter(e => e != this.currentName)
            } else {
                if (this.multiple) {
                    arr.unshift(this.currentName)
                } else {
                    arr = [this.currentName]
                }
            }
            let val = arr.join(',')
            this.$emit('input', val)
            this.$emit('change', val)
        },
        removeHandler(id) {
            let arr = this.value ? this.value.split(',') : []
            arr = arr.filter(e => e != id)
            // this.selectValue = arr.join(',')
            this.$emit('input', arr.join(','))
            this.handleChange(arr.join(','))
            console.log(this.value, 'this.value-------')
        },
        handleChange(val) {
            this.$emit('change', val)
        },

        handleShow() {
            if (!this.disabled) {
                this.dialogVisible = true
            }
        },
        handleCompanyClick(node) {
            this.lr_loadDepartments && this.lr_loadDepartments(node.f_CompanyId)
            this.selectCompanyId = node.f_CompanyId
        },
        handleDepartmentClick(node) {
            if (this.multiple) return
            this.lr_loadDepartment && this.lr_loadDepartment(node.f_DepartmentId)
            this.selectValue = node.f_DepartmentId
            // this.$refs.main.focus()
            // this.$refs.main.blur()
            this.dialogVisible = false

            this.handleChange(node)

        },
        handleInputClear() {
            this.handleChange()
        },
        handleOpened() {
            if (this.value) {
                this.$refs.maintree && this.$refs.maintree.setCheckedKeys(this.value.split(','), true)
            }
            else {
                this.$refs.maintree.setCheckedKeys([])
            }
        },
        handleSelectMultiple() {
            const checkedKeys = this.$refs.maintree.getCheckedKeys()
            // const halfCheckedKeys = this.$refs.maintree.getHalfCheckedKeys()
            // const selectValue = checkedKeys.concat(halfCheckedKeys)
            const selectValue = checkedKeys
            if (this.hasCurrent) {
                selectValue.unshift(this.currentName)
            }
            this.selectValue = String(selectValue)
            // this.$refs.main.focus()
            // this.$refs.main.blur()
            this.dialogVisible = false

            if (!this.selectValue) {
                this.handleChange()
            }
            else {
                this.handleChange(this.departmentList.filter(t => selectValue.indexOf(t.f_DepartmentId) != -1))
            }

            //this.$refs.maintree.setCheckedKeys([])
        }
    }
}
</script>
<style scoped lang="less">
.tishi {
    height: 20px;
    line-height: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: bottom;
    margin-bottom: -1px;
}
.add-btn {
    width: auto;
    padding: 0 12px;
    display: inline-block;
    font-size: 12px;
    color: #2c71fa;
    background: #f5f7f9;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    margin-right: 10px;
    margin: 4px 0;
    margin-right: 8px;
    cursor: pointer;
}

.tag-mode {
    flex-wrap: wrap;
    border: 1px dashed #bfbfbf;
    border-radius: 4px;
    height: 28px;
    cursor: pointer;
    padding: 2px 3px;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 4px;

    .add-btn {}

}

::v-deep {
    .tag-mode {
        .remove-btn {
            transform: scale(0.8);
            top: -13px;
            line-height: 21px;
        }

        .tag-item.isForm {
            height: 22px !important;
            margin: 0;
            border-radius: 3px;
            padding-left: 5px;
            padding-right: 5px;
            font-size: 12px;
            line-height: 22px;
            padding-right: 5px;
            color: #000;
        }

        .tag-item .name {
            padding-right: 0;
            line-height: 22px;
        }

        .tag-right {
            line-height: 22px;
            width: unset !important;
        }

        .tag-item .avatar {
            margin-right: 4px;
        }
    }

}
</style>